import Vue from "vue";
import escapeStringRegexp from "escape-string-regexp";

Vue.filter("highlightText", (text, highlightedText) => {
  text = ""+text;
  const escapedString = escapeStringRegexp(highlightedText);
  const regExp = new RegExp("(" + escapedString + ")", "gi");
  const matches = text.match(regExp);
  return matches
    ? text.replace(
      regExp,
      "<span class=\"highlight font-weight-bold py-2 px-0\">$1</span>"
    )
    : text;
});
